import QuickAddClient from "../../components/ui/QuickAddClient";
import OptionalSection from "../../components/ui/OptionalSection";
import { useRef as useSaveRef } from "react";
import { Snackbar } from "@material-ui/core";
// import http from "../../reduxSaga/sagas/requests/http-common";
import update from "immutability-helper";
// import Blob from "blob";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useRef, useState } from "react";
import { Alert } from "@material-ui/lab";
import React from "react";
import $ from "jquery";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Check from "@material-ui/icons/Check";
import SettingsIcon from "@material-ui/icons/Settings";
import Button from "@material-ui/core/Button";
import PurchaseService from "../../services/PurchaseOrder";
import CurrencyService from "../../services/CurrencyService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import ManufacturingBatchService from "../../services/ManufacturingBatchService";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import UtilsFormule from "../../utils/UtilsFormule";
import { Link, useNavigate } from "react-router-dom";
import RateService from "../../services/RateService";
import WarehouseService from "../../services/WarehouseService";
import Societe from "../../services/Societe";
import SellingService from "../../services/SellingService";
import StockOfProductSale from "./StockOfProductSale";
import withLoader from "../../components/layouts/WithLoader";
import DiscountService from "../../services/DiscountService";
import UtilsFormuleSell from "../../utils/UtilsFormuleSell";

const useQontoStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    height: 22,
    alignItems: "center",
  },
  active: {
    color: "#000000",
  },
  circle: {
    width: 8,
    height: 8,
    color: "#fff",
    borderRadius: "50%",
    backgroundColor: "#000000",
  },
  completed: {
    color: "#000000",
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <Check className={classes.completed} />
      ) : (
        <div className={classes.circle} />
      )}
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#000",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  active: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      color: "#000000",
    },
  },
  completed: {
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));

function getSteps() {
  return [
    "Inscrivez le devis ou les produits ",
    "Créer un bon de commande  ",
    "Confirmer les produits",
    "Générer le bon de livraison ",
    "Finaliser",
  ];
}
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
  // le menu doit passer au-dessus du champ fichier (.custom-file-input a z-index: 2)
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};
const AddBDCSellDepot = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableProducts, setAvailableProducts] = useState([]);
  const [quotationReference, setQuotationReference] = useState("");
  const [bdcReference, setBdcReference] = useState("");
  const [clientId, setClientId] = useState(0);
  const [productId, setProductId] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [tva, setTva] = useState(0);
  const [promotion, setPromotion] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [productTableData, setProductTableData] = useState([]);
  const [lineNote, setLineNote] = useState("");
  const [documentLanguage, setDocumentLanguage] = useState("fr");
  const [productTableDataForLivraison, setProductTableDataForLivraison] = useState([]);

  const [productMapById, setProductMapById] = useState([]);
  const [promotionType, setPromotionType] = useState("pourcentage");
  const [discountType, setDiscountType] = useState("pourcentage");
  const [warehousePriceId, setWarehousePriceId] = useState(0);
  const [disableTerminer, setDisableTerminer] = useState(false);
  const [transactions, setTransactions] = useState(null);
  const [document, setDocument] = useState(null);


  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();

  const [ordreTitle, setOrdreTitle] = useState("");
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState("");
  const [ordreDateLimite, setOrdreDateLimite] = useState("any");
  const [ordreUrl, setOrdreUrl] = useState("any");
  const [bdcUrl, setBDCUrl] = useState("any");
  const [ordreDesignation, setOrdreDesignation] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);

  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [clientSelectedOption, setClientSelectedOption] = useState(null);
  const [allProducts, setAllProducts] = React.useState([{}]);
  const [activeStep, setActiveStep] = React.useState(0);
  const [clientSelectPlaceHolder, setClientSelectPlaceHolder] =
    useState("Choisir...");

  const [createBDCFromDevis, setCreateBDCFromDevis] = useState(false);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");

  const [availableBDCSelectedOption, setAvailableBDCSelectedOption] =
    useState(null);
  const [allAvailableBDC, setAllAvailableBDC] = React.useState([{}]);
  const [availableBDCSelectPlaceHolder, setAvailableBDCSelectPlaceHolder] =
    useState("Choisir...");

  const [
    availableDevisNotRelatedToBDCSelectedOption,
    setAvailableDevisNotRelatedToBDCSelectedOption,
  ] = useState(null);
  const [
    allAvailableDevisNotRelatedToBdc,
    setAllAvailableDevisNotRelatedToBdc,
  ] = React.useState([{}]);
  const [
    availableDevisNotRelatedToBDCSelectPlaceHolder,
    setAvailableDevisNotRelatedToBDCSelectPlaceHolder,
  ] = useState("Choisir...");
  const [allModeProduct, setAllModeProduct] = React.useState([
    { value: 1, label: "Local" },
    { value: 2, label: "Import" },
  ]);
  const [selectedOptionMode, setSelectedOptionMode] = useState(null);
  const [modeProduct, setModeProduct] = useState(null);

  const [allCurrencies, setAllCurrencies] = React.useState([
    { value: "EUR", label: "Euro" },
    { value: "USD", label: "US Dollar" },
    { value: "AED", label: "United Arab Emirates Dirham" },
    { value: "CAD", label: "Canadian Dollar" },
    { value: "CNY", label: "Chinese Yuan" },
  ]);
  const [modeProductSelectPlaceHolder, setModeProductSelectPlaceHolder] =
    useState("Choisir...");
  const [clients, setClients] = useState([]);

  const [labelDevise, setLabelDevise] = useState("Prix en DNT");
  const [montantDevis, setMontantDevis] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [deviseChoosen, setDeviseChoosen] = useState(null);
  const [selectedOptionDevis, setSelectedOptionDevis] = useState(null);
  const [deviseSelectPlaceHolder, setDeviseSelectPlaceHolder] =
    useState("Choisir...");
  const [availableLot, setAvailableLot] = useState([]);
  const [selectedOptionLot, setSelectedOptionLot] = useState(null);
  const [allLot, setAllLot] = useState([]);
  const [idLot, setIdLot] = useState(0);
  const [lotSelectPlaceHolder, setLotSelectPlaceHolder] =
    useState("Choisir...");
  const [promotionPercentage, setPromotionPercentage] = useState(0);
  const [bcPriceHt, setBcPriceHt] = useState(0);
  const [bcPriceTt, setBcPriceTt] = useState(0);
  const [initialPriceHTC, setInitialPriceHTC] = useState(0);
  const [buyingPrice, setBuyingPrice] = useState(0);
  const [priceTT, setPriceTT] = useState(0);
  const [discountFinal, setDiscountFinal] = useState(0);

  const [availableRates, setAvailableRates] = useState([]);
  const [allRates, setAllRates] = useState([]);

  const [rateSelectPlaceHolder, setRateSelectPlaceHolder] =
    useState("Choisir une taxe");
  const [rateChoosen, setRateChoosen] = useState(null);
  const [rateName, setRateName] = useState("");
  const [rateCode, setRateCode] = useState("");
  const [rateType, setRateType] = useState("");
  const [rateTypeTax, setRateTypeTax] = useState("");
  const [rateTypeTVA, setRateTypeTVA] = useState("");

  const [valueRate, setValueRate] = useState();
  const [refBill, setRefBill] = useState("");

  const [rateTableData, setRateTableData] = useState([]);
  const [selectedOptionRate, setSelectedOptionRate] = useState(null);
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [allWarehousePrice, setAllWarehousePrice] = useState([{}]);

  const [warehousesSource, setWarehousesSource] = useState([]);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [estimUnitPrice, setEstimUnitPrice] = useState("");
  const [estimQte, setEstimQte] = useState("");
  const [estimTva, setEstimTva] = useState("");
  const [estimDevise, setEstimDevise] = useState("");

  const [productBloc, setProductBloc] = useState(false);
  const [allClients, setAllClients] = useState([]);
  const [refBC, setRefBC] = useState(null);
  const [bCFile, setBCFile] = useState([]);
  const [onGetStockProduct, setOnGetStockProduct] = useState(false);
  const [nameProductStock, setNameProductStock] = useState();
  const [productIdStock, setProductIdStock] = useState();
  const [conditionCommercialClient, setConditionCommercialClient] = useState(null);
  const [showConditionCommercialClient, setShowConditionCommercialClient] = useState(false);
  const [seuil, setSeuil] = useState();
  const [products, setProducts] = React.useState([{}]);


  const steps = getSteps();
  const savingRef = useSaveRef(false);
  const printAfterSaveRef = useSaveRef(false);
  const [saving, setSaving] = useState(false);
  const [showQuickClient, setShowQuickClient] = useState(false);
  // a client created from the form is added to the list and selected right away
  const onClientCreated = (societe) => {
    const option = { value: societe.id, label: societe.title };
    setAllClients((old) => [...old, option]);
    onChangeSelectedClient(option);
  };
  const autoRunRef = useSaveRef(false);
  // live totals: same computation the wizard used to run when leaving the products step
  useEffect(() => {
      console.log("productTableData", productTableData);
      let result = UtilsFormuleSell.CalculateNewSELLINGPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setBcPriceHt(sumPromotionHt);
      setBcPriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
  }, [productTableData, discount, discountType]);
  // single page: "Enregistrer" runs the former wizard steps (checks, totals, save) in a row
  const handleSave = () => {
    autoRunRef.current = true;
    handleNext();
  };
  useEffect(() => {
    if (activeStep > 2) {
      autoRunRef.current = false;
    } else if (autoRunRef.current && activeStep >= 1) {
      handleNext();
    }
  }, [activeStep]);
  // titre et note par défaut : "Bon de commande pour {client}" tant que l'utilisateur ne les a pas modifiés
  const titleEditedRef = useRef(false);
  const noteEditedRef = useRef(false);

  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });
  const [note, setNote] = useState();

  const [typeProduit, setTypeProduit] = useState(1);

  useEffect(() => {

    Societe.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((reponse) => {
        setClients(reponse.data["Societe"]);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : il ya un probléme pour obtenir les clients"
        );
      });
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setWarehousesSource(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });

    ManufacturingBatchService.getManufacturingBatchByIdUser(
      getCurrentUserId(),
      0
    ).then((response) => {
      setAvailableLot(response.data);
    });

    RateService.getAllRatesByIdUserAndIsDeletedAndTypeTax(
      getCurrentUserId(),
      0,
      1
    ).then((result) => {
      console.log("result", result.data["success"]);
      if (result.data["success"]) {
        setAvailableRates(result.data["success"]);
      } else {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      }
    });
  }, []);
  useEffect(() => {
    warehousesSource &&
      warehousesSource.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.name },
          ]);
        }
        //here
      });
  }, [warehousesSource]);
  useEffect(() => {
    // WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
    WarehouseService.getAllPriceWarehouse(getCurrentUserId())
      .then((response) => {
        console.log("-----------------------------response", response);

        // Check if response contains data and success flag
        if (response?.data?.success && Array.isArray(response.data.success)) {
          response.data.success.forEach((element) => {
            let exist = false;

            // Check if the element already exists in the allWarehouseSource
            if (element?.id !== undefined) {
              exist = allWarehouseSource.some(
                (warehouse) => warehouse.value === element.id
              );
            }

            // If element doesn't exist, add to the warehouse price state
            if (!exist) {
              setAllWarehousePrice((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.name },
              ]);
            }
          });
        } else {
          // Handle case where the response doesn't have the expected data
          setErrorAlertText("Erreur : pas de dépôt"); // Set an error message
        }
      })
      .catch((e) => {
        // Log the error and set the error message if the API request fails
        console.log("Error in getAllPriceWarehouse:", e);
        setErrorAlertText("Erreur : impossible de récupérer les prix des dépôts");
      });
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  useEffect(() => {
    availableLot &&
      availableLot.map((element) => {
        setAllLot((oldArray) => [
          ...oldArray,
          { value: element.id, label: element.serialNumber },
        ]);
      });
  }, [availableLot]);
  useEffect(() => {
    clients &&
      clients.map((element, i) => {
        let exist = false;
        if (allClients.length !== 0) {
          for (let index = 0; index < allClients.length; index++) {
            if (allClients[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllClients((oldArray) => [
            ...oldArray,
            {
              value: element.id, label: element.title, customElements: {
                seuil: element.seuil,
              }
            },
          ]);
        }
      });
  }, [clients]);

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedWarehousePrice = (selectedOptionn) => {
    setSelectedOption();
    setWarehousePriceId(selectedOptionn.value);
    // setWarehouseSelectPlaceHolder(selectedOptionn.label);
    // console.log("warehouseSourceID", selectedOptionn.value);
  };

  useEffect(() => {
    setAllRates([]);

    availableRates &&
      availableRates.map((element, i) => {
        setAllRates((oldArray) => [
          ...oldArray,
          {
            value: element.id,
            label: element.name,
            customElements: {
              code: element.code,
              type: element.type,
              value: element.value,
              typeTVA: element.typeTVA,
              typeTax: element.typeTax,
            },
          },
        ]);
      });
  }, [availableRates]);

  useEffect(() => {
    if (ordreDateLimite === ":59") {
      setOrdreDateLimite("any");
    }
  }, [ordreDateLimite]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };

  const onChangeOrdreTitleHandler = (event) => {
    titleEditedRef.current = event.target.value.trim() !== "";
    setOrdreTitle(event.target.value);
  };

  //   const onChangeOrdreUrlHandler = (event) => {
  //     setOrdreUrl(event.target.value);
  //   };
  const onChangeBDCUrlHandler = (event) => {
    setBDCUrl(event.target.value);
  };
  const onChangeOrdreDesignationHandler = (event) => {
    noteEditedRef.current = event.target.value.trim() !== "";
    setOrdreDesignation(event.target.value);
  };
  // const onChangeLimitDateHandler = (event) => {
  //   setOrdreDateLimite(event.target.value.concat(":59"));
  // };

  const onChangeUnitPriceHandler = (event) => {
    setUnitPrice(event.target.value);
    setEstimUnitPrice(event.target.value)
    setLabelDevise("Prix U en DNT");
    setMontantDevis(event.target.value);
  };

  const onChangeTvaHandler = (event) => {
    setTva(event.target.value);
  };

  const onChangePromotionHandler = (event) => {
    setPromotionPercentage(event.target.value);
  };
  // const onChangeDiscountHandler = (event) => {
  //   setDiscount(event.target.value);
  //   CalculateNewSELLINGPriceAfterDiscount(event.target.value, discountType);
  // };

  // const onChangeDiscountTypeHandler = (event) => {
  //   setDiscountType(event.target.value);
  //   CalculateNewSELLINGPriceAfterDiscount(discount, event.target.value);
  // };
  const CalculateNewSELLINGPriceAfterDiscount = (discount, discountType) => {
    let result = UtilsFormuleSell.CalculateNewSELLINGPriceAfterDiscount(
      productTableData,
      discount,
      discountType
    );
    console.log("result discount", result);
    let sumPromotionHt = result[1];
    let sumPromotionTt = result[2];
    let sumPriceHt = result[3];

    setBcPriceHt(sumPromotionHt);
    setBcPriceTt(sumPromotionTt);
    setInitialPriceHTC(sumPriceHt);
    setBuyingPrice(sumPromotionHt);
    setPriceTT(sumPromotionTt);
    setDiscountFinal(result[4]);
  };

  const onChangeQuotationReferenceHandler = (selectedOptionn) => {
    setQuotationReference(selectedOptionn.value);
    setAvailableDevisNotRelatedToBDCSelectedOption();

    setAvailableDevisNotRelatedToBDCSelectPlaceHolder(selectedOptionn.label);
  };

  const onChangeBDCReferenceHandler = (selectedOptionn) => {
    setBdcReference(selectedOptionn.value);
    setAvailableBDCSelectedOption();

    setAvailableBDCSelectPlaceHolder(selectedOptionn.label);
  };

  const onDeleteProduct = (id) => {
    setProductTableData(productTableData.filter((item) => item.id !== id));
    setProductMapById(productMapById.filter((item) => item.id !== id));
  };

  const onGetBDCByReference = () => {
    //here
    if (bdcReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
    } else {
      SellingService.getBDCByRef(bdcReference, getCurrentUserId())
        .then((response) => {
          console.log("getBDCByRef", response.data.success);

          if (Object.keys(response.data)[0] === "success") {
            setProductMapById([]);
            setProductTableData([]);
            response.data.success.sales.forEach((element) => {
              let lot = 0;
              if (element.manufacturingBatch != null) {
                lot = element.manufacturingBatch.id;
              }
              setProductMapById((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  id: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);

              setProductTableData((previoustate) => [
                ...previoustate,
                {
                  productRef: element.product.name,
                  id: element.product.id,
                  initialPriceHtc: element.initialPriceHtc,
                  quantity: element.quantity,
                  tva: element.tva,
                  sellingPrice: element.sellingPrice,
                  idLot: lot,
                  currency: element.currency,
                  currencyPrice: element.currencyPrice,
                  exchangeRate: element.exchangeRate,
                  isImport: element.isImport,
                  htPrice: element.sellingPrice * element.quantity,
                  ttPrice: element.priceTt * element.quantity,
                  promotionPercentage: element.promotionPercentage,
                  note: element.note,
                },
              ]);
            });
            response.data.success.ratePPs.forEach((element) => {
              setRateTableData((previoustate) => [
                ...previoustate,
                {
                  idRate: element.idRate,
                  name: element.name,
                  value: element.value,
                  code: element.code,
                  type: element.type,
                  typeTax: element.typeTax,
                  typeTVA: element.typeTVA,
                  refBill: element.refBill,
                },
              ]);
            });
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "info : aucun bon de commande  avec ce réference   "
            );
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const onGetDevisByReference = () => {
    if (quotationReference === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune réference");
      setCreateBDCFromDevis(false);
      setProductMapById([]);
      setProductTableData([]);
    } else {
      SellingService.getDevisByRef(quotationReference, getCurrentUserId())
        .then((response) => {
          console.log("responseDevis", response);
          if (Object.keys(response.data)[0] === "success") {
            if (
              response.data.success.state === 0 ||
              response.data.success.state === 3
            ) {
              setProductMapById([]);
              setProductTableData([]);
              response.data.success.sales.forEach((element) => {
                let lot = 0;
                if (element.manufacturingBatch != null) {
                  lot = element.manufacturingBatch.id;
                }
                setProductMapById((previoustate) => [
                  ...previoustate,
                  {
                    productRef: element.product.name,
                    idProduct: element.product.id,
                    initialPriceHtc: element.initialPriceHtc,
                    quantity: element.quantity,
                    tva: element.tva,
                    sellingPrice: element.sellingPrice,
                    idLot: lot,
                    currency: element.currency,
                    currencyPrice: element.currencyPrice,
                    exchangeRate: element.exchangeRate,
                    isImport: element.isImport,
                    htPrice: element.sellingPrice * element.quantity,
                    ttPrice:
                      Math.round(element.priceTt * element.quantity * 1000) /
                      1000,
                    // ttPrice: element.priceTt * element.quantity,

                    promotionPercentage: element.promotionPercentage,
                    note: element.note,
                  },
                ]);

                setProductTableData((previoustate) => [
                  ...previoustate,
                  {
                    productRef: element.product.name,
                    idProduct: element.product.id,
                    initialPriceHtc: element.initialPriceHtc,
                    quantity: element.quantity,
                    tva: element.tva,
                    sellingPrice: element.sellingPrice,
                    idLot: lot,
                    currency: element.currency,
                    currencyPrice: element.currencyPrice,
                    exchangeRate: element.exchangeRate,
                    isImport: element.isImport,
                    htPrice: element.sellingPrice * element.quantity,
                    ttPrice:
                      Math.round(element.priceTt * element.quantity * 1000) /
                      1000,
                    // ttPrice: element.priceTt * element.quantity,
                    promotionPercentage: element.promotionPercentage,
                    note: element.note,
                  },
                ]);
              });
              response.data.success.ratePPs.forEach((element) => {
                setRateTableData((previoustate) => [
                  ...previoustate,
                  {
                    idRate: element.idRate,
                    name: element.name,
                    value: element.value,
                    code: element.code,
                    type: element.type,
                    typeTax: element.typeTax,
                    typeTVA: element.typeTVA,
                    refBill: element.refBill,
                  },
                ]);
              });

              setCreateBDCFromDevis(true);
              setDocumentLanguage((response.data.success && response.data.success.language) || "fr");
              // setDiscountType("pourcentage");
              setDiscount(response.data.success.discountPercentage);
              setClientId(response.data.success.clientId);
              setClientSelectPlaceHolder(response.data.success.clientTitle);
              setBuyingPrice(response.data.success.buyingPrice);
            } else {
              setOpenInfoAlert(true);
              setInfoAlertText("Devis est deja confirmé");
            }
          } else if (Object.keys(response.data)[0] === "empty") {
            setOpenInfoAlert(true);
            setInfoAlertText("info : aucun devis  avec ce réference");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    }
  };

  const handleNext = () => {
    if (activeStep === 0) {
      console.log("productTableData", productTableData);
      let result = UtilsFormuleSell.CalculateNewSELLINGPriceAfterDiscount(
        productTableData,
        discount,
        discountType
      );
      console.log("result discount handleNext", result);

      let sumPromotionHt = result[1];
      let sumPromotionTt = result[2];
      let sumPriceHt = result[3];

      setBcPriceHt(sumPromotionHt);
      setBcPriceTt(sumPromotionTt);
      setInitialPriceHTC(sumPriceHt);
      setBuyingPrice(sumPromotionHt);
      setPriceTT(sumPromotionTt);
      setDiscountFinal(result[4]);
    }
    if (activeStep === 0 && productBloc === false) {
      setOpenInfoAlert(true);
      setInfoAlertText(
        "Vous devez choisir un dépôt et appuyer sur le bouton flèche"
      );
    } else if (activeStep === 0 && productTableData.length > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 0 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun produit ");
    } else if (activeStep === 1 && ordreTitle === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le champ de titre est vide ");
    } else if (activeStep === 1 && clientId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucun client ");
    } else if (activeStep === 1 && ordreDesignation === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : aucune description ");
    } else if (activeStep === 1 && seuil !== null && seuil !== undefined && seuil < bcPriceTt) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Le montant de la BDC dépasse le seuil de ce client ");
    } else if (activeStep === 1) {
      if (refBC !== null) {
        SellingService.verifieBCSellExistanceByReference(
          getCurrentUserId(),
          refBC
        )
          .then((response) => {
            if (response.data["NotExist"]) {
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              // setProductTableData(
              //   UtilsFormuleSell.CalculateNewSellingDataTableAfterDiscount(
              //     productTableData,
              //     discountFinal
              //   )
              // );
            } else if (response.data["Exist"]) {
              setOpenInfoAlert(true);
              setInfoAlertText("Info : ce réference existe dans le system");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          });
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);

      }

      // setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 2) {
      console.log("productTableData in step 2",productTableData)
      if (createBDCFromDevis === false) {
        var bdcModel = {};
        if (discountType === "percentage") {
        } else {
          if (discount === 0) {
          } else {
          }
        }
        bdcModel = {
          ref: refBC,
          buyingPrice: buyingPrice,
          description: ordreDesignation,
          discountPercentage: discountFinal,
          idClient: clientId,
          refDevis: "any",
          idUser: getCurrentUserId(),
          initialPriceHtc: initialPriceHTC,
          note: ordreDesignation,
          path: "any",
          priceHT: bcPriceHt,
          priceTT: bcPriceTt,
          
          sales: productTableData,
          title: ordreTitle,
          language: documentLanguage,
          estimatedDeliveryDate: estimatedDeliveryDate || null,
          ratePPps: rateTableData,
          warehouseId: warehouseSourceId,
        };
      } else {
        bdcModel = {
          description: ordreDesignation,
          refDevis: quotationReference,
          idUser: getCurrentUserId(),
          note: ordreDesignation,
          path: "any",
          title: ordreTitle,
          language: documentLanguage,
          estimatedDeliveryDate: estimatedDeliveryDate || null,
          ref: refBC,
          ratePPps: rateTableData,
          warehouseId: warehouseSourceId,
          buyingPrice: buyingPrice,
          discountPercentage: discountFinal,
          idClient: clientId,
          initialPriceHtc: initialPriceHTC,
          priceHT: bcPriceHt,
          priceTT: bcPriceTt,
          sales: productTableData,

        };
      }

      console.log(JSON.stringify(bdcModel));
      if (bCFile.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", bCFile);

        SellingService.uploadFile("/uploadFile/BonCommandeSale", uploadData)
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              bdcModel.path = response.data.success;
              onSendQuotationToBackendSystem(bdcModel);
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur : erreur lors de l'enregistrment du fichier"
            );
          });
      } else {
        onSendQuotationToBackendSystem(bdcModel);
      }
    } else if (activeStep === 3) {

      let validatePurchaseOrderToRealWarehouseModel = {
        idWarhouse: warehouseSourceId,
        idUser: getCurrentUserId(),
        productStockedByWarehouseModels: productTableDataForLivraison,
        reference: sessionStorage.getItem("refBDC"),
        pathBonDeLivraison: "any",
      };

      console.log(
        "validatePurchaseOrderToRealWarehouseModel",
        JSON.stringify(validatePurchaseOrderToRealWarehouseModel)
      );
      setDisableTerminer(true)
      startLoading();
      SellingService.validateSalesOrderToRealWarehouse(
        validatePurchaseOrderToRealWarehouseModel
      )
        .then((response) => {
          console.log("validateSalesOrderToRealWarehouse", response);
          if (Object.keys(response.data)[0] === "success") {
            setOpenSuccessAlert(true);
            setTransactions(response.data["transactionOperationsResponse"]);
            setDocument(response.data.success);
            setSuccessAlertText("Enregistrement avec succées");

            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setTimeout(() => {
              if (printAfterSaveRef.current) {
                sessionStorage.setItem("refDocument", sessionStorage.getItem("refBDC"));
                sessionStorage.setItem("typeDocument", "bdc");
                navigate("/getDocumentSalesByRef?print=1");
              } else {
                navigate(`/bonCommandeVente`);
              }
            }, 2000);
          } else if (Object.keys(response.data)[0] === "error") {
            setOpenErrorAlert(true);
            setErrorAlertText(
              "Erreur : il ya un probléme au niveau de serveur"
            );
          } else if (Object.keys(response.data)[0] === "IsCompleted") {
            setOpenInfoAlert(true);
            setInfoAlertText("Info : l'opération est déja terminée");
          } else if (Object.keys(response.data)[0] === "InvalidateReference") {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "Info : la réference de d'achat ou de facture n'est pas valide "
            );
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connexion");
        }).finally(() => {
          stopLoading();
        });

    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    PurchaseService.getAllBDCNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableBDC(backendData);
          setAvailableBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    PurchaseService.getAllDevisNotRelatedToBDCeNotArchived()
      .then((response) => {
        if (Object.keys(response.data)[0] === "empty") {
          setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Vide");
        } else if (Object.keys(response.data)[0] === "success") {
          let backendData = [{}];
          response.data.success.map((element) => {
            let elem = { value: element, label: element };
            backendData.push(elem);
          });
          setAllAvailableDevisNotRelatedToBdc(backendData);
          setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Choisir...");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });

    setCreateBDCFromDevis(false);
    setProductMapById([]);
    setProductTableData([]);
    setUnitPrice(0);
    setQuantity(1);
    setTva(0);
    setPromotion(0);
    setActiveStep(0);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    console.log("selectedOptionn", selectedOptionn);
    setSelectedOption();
    setProductId(selectedOptionn?.value);
    setProductSelectPlaceHolder(selectedOptionn?.label);
    setEstimUnitPrice(selectedOptionn.customElements.price);
    setEstimQte(selectedOptionn.customElements.quantity);
    setEstimTva(selectedOptionn.customElements.tva);
    setEstimDevise(selectedOptionn.customElements.devise);
    setUnitPrice(selectedOptionn.customElements.price);
    setMontantDevis(selectedOptionn.customElements.price);
    setTva(selectedOptionn.customElements.tva);
  };
  const onChangeSelectedClient = (selectedOptionn) => {
    if (!noteEditedRef.current && selectedOptionn && selectedOptionn.label) {
      setOrdreDesignation("Bon de commande pour " + selectedOptionn.label);
    }
    if (!titleEditedRef.current && selectedOptionn && selectedOptionn.label) {
      setOrdreTitle("Bon de commande pour " + selectedOptionn.label);
    }
    setSelectedOption();
    setClientId(selectedOptionn.value);
    setClientSelectPlaceHolder(selectedOptionn.label);

    startLoading();
    DiscountService.getConditionsCommercialTiersByClient(getCurrentUserId(), selectedOptionn.value, 1, 0).then((response) => {
      if (response.data.success) {
        console.log("response",response.data.success)
        setConditionCommercialClient(response.data.success)
        if (response.data.success.conditionCommercialTiers?.amount !== 0) {
          setDiscount(response.data.success.conditionCommercialTiers?.amount);
          setDiscountType("montant");
          CalculateNewSELLINGPriceAfterDiscount(response.data.success.conditionCommercialTiers?.amount, "montant");
        } else if (response.data.success.conditionCommercialTiers?.percent !== 0) {
          setDiscount(response.data.success.conditionCommercialTiers?.percent);
          setDiscountType("pourcentage");
          CalculateNewSELLINGPriceAfterDiscount(response.data.success.conditionCommercialTiers?.percent, "pourcentage");
        }
        setShowConditionCommercialClient(true);
      } else if (response.data.empty) {
        setShowConditionCommercialClient(false);
        setDiscount(0);
        setDiscountType("pourcentage");
        CalculateNewSELLINGPriceAfterDiscount(0, "pourcentage");
      }
      console.log("products after cc", productTableData)

      setSeuil(selectedOptionn.customElements.seuil);
    }).catch((error) => {

    }).finally(() => {
      stopLoading();
    })

  };

  const onSendQuotationToBackendSystem = (bdcModel) => {
    if (savingRef.current) {
      return;
    }
    savingRef.current = true;
    setSaving(true);
    console.log("bdcModel", JSON.stringify(bdcModel));
    startLoading()
    SellingService.addBC(bdcModel)
      .then((response) => {
        if (Object.keys(response.data)[0] === "Bon_De_Commande") {
          savingRef.current = false;
          setSaving(false);
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          sessionStorage.setItem("refBDC", response.data?.Bon_De_Commande?.ref)

          SellingService.getSalesByRefCByRefBDC(
            sessionStorage.getItem("refBDC"),
            getCurrentUserId()
          )
            .then((response2) => {
              console.log("response2", response2);
              if (response2.data.InvalidReference) {
                savingRef.current = false;
          setSaving(false);
          setOpenInfoAlert(true);
                setInfoAlertText("Info : la réference est invalide");
              } else if (Object.keys(response2.data)[0] === "RelatedToFacture") {
                savingRef.current = false;
          setSaving(false);
          setOpenInfoAlert(true);
                setInfoAlertText("Info : cette achat est liée a une facture");
              } else if (Object.keys(response2.data)[0] === "AlreadyCompleted") {
                savingRef.current = false;
          setSaving(false);
          setOpenInfoAlert(true);
                setInfoAlertText("Info :l'operation est terminé");
              } else if (Object.keys(response2.data)[0] === "error") {
                savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Aucun bon de commande de ce référence");
              } else {
                setProducts([]);
                response2.data.ProductsSales.map((element) => {
                  setProducts((oldArray) => [
                    ...oldArray,
                    {
                      value: element.idProductSale,
                      label: element.productName,
                      customElements: {
                        quantity: element.quantity,
                        currentQte: element.currentQte,
                      },
                    },
                  ]);
                });
                response2.data.ProductsSales.map((element, index) => {
                  setProductTableDataForLivraison((previoustate) => [
                    ...previoustate,
                    {
                      idProductPurchase: element.idProductSale,
                      stockedQte: "" + element.currentQte,
                      productName: element.productName,
                      type: typeProduit,
                      note: note,
                    },
                  ]);
                });
              }
            })
            .catch((error) => {
              savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
              setErrorAlertText("Erreur : " + error);
            });
          // setTimeout(() => {
          //   navigate(`/bonCommandeVente`);
          // }, 2000);
        } else {
          savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch((error) => {
        savingRef.current = false;
          setSaving(false);
          setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      }).finally(() => {
        stopLoading();
      });
  };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const onChangeMontantDevisHandler = (event) => {
    setMontantDevis(0);
    setMontantDevis(event.target.value);
  };
  const onHandleClickTauxChange = () => {
    if (deviseChoosen !== null) {
      getCurrencyRate(deviseChoosen);
    }
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        setTauxChange(response.data);
        setLabelDevise(
          "TAUX D'ECH (" +
          response.data.toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          ") ESTI DNT (" +
          (unitPrice * response.data).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          " )"
        );
      });
    } catch (error) {
      console.log("error currency", error);
    }
  };
  const calculDevis = () => {
    return (
      <div className="col-sm-6">
        <div className="input-group">
          <label>{labelDeviseTest()}</label>
          <div className="input-group-prepend" style={{ width: "89%" }}>
            <input
              onChange={onChangeMontantDevisHandler}
              type="number"
              min="0"
              id="montantDevise"
              className="form-control"
            />
          </div>
          <div className=" input-group-append">
            <button
              onClick={onHandleClickTauxChange}
              type="button"
              class="btn btn-dark"
            >
              {" "}
              <i class="fas fa-solid fa-dollar-sign"></i>{" "}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const onChangeSelectedLot = (selectedOptionn) => {
    setSelectedOptionLot();
    setIdLot(selectedOptionn.value);
    setLotSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedDevis = (selectedOptionn) => {
    setSelectedOptionDevis(selectedOptionn.value);
    setDeviseChoosen(selectedOptionn.value);
    setDeviseSelectPlaceHolder(selectedOptionn.label);
  };
  const devise = () => {
    if (modeProduct === 2) {
      return (
        <div className="col-sm-8">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Devise</label>
                <Select
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedOptionDevis}
                  onChange={onChangeSelectedDevis}
                  options={allCurrencies}
                  placeholder={deviseSelectPlaceHolder}
                />
              </div>
            </div>
            {calculDevis()}
          </div>
        </div>
      );
    }
  };
  const onChangeSelectedMode = (selectedOptionn) => {
    setSelectedOptionMode(selectedOptionn.value);
    setModeProduct(selectedOptionn.value);
    setModeProductSelectPlaceHolder(selectedOptionn.label);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "initialPriceHtc",
      text: "Prix.U.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "tva",
      text: "TVA",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },
    {
      dataField: "sellingPrice",
      text: "Prix.U.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "6%" };
      },
    },

    {
      dataField: "htPrice",
      text: "Montant.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Montant.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    // {
    //   dataField: "promotionPercentage",
    //   text: "Remise",
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "note",
      text: "Note",
      headerAlign: "center",
      formatter: (cell) => cell || "",
    },
    {
      dataField: "idProduct",
      text: "Stock",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm "
            data-toggle="modal"
            data-target="#edit-brand"
          >
            <i class="fas fa-eye"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);

          setProductIdStock(row.idProduct);
          setNameProductStock(row.productRef);
          setOnGetStockProduct(true);
        },
      },
    },
    {
      dataField: "idProduct",
      text: "SUP",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          // console.log("productTableData", row);
          // console.log("productTableData", productTableData);
          // console.log("productMapById", productMapById);


          const updatedProductTableData = productTableData.filter(
            (item) => row.id ? item.id !== row.id : item.idProduct !== row.idProduct
          );

          const updatedProductMapById = productMapById.filter(
            (item) => row.id ? item.id !== row.id : item.idProduct !== row.idProduct
          );

          // Update the state with the filtered arrays
          setProductTableData(updatedProductTableData);
          setProductMapById(updatedProductMapById);

        },
      },

    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  function handleTableChangeRate({ rateTableData }) {
    return rateTableData;
  }

  const onChangeSelected = (selectedOption) => {
    console.log("selected", selectedOption);
    setSelectedOptionRate(selectedOption);
    setRateChoosen(selectedOption.value);
    setRateName(selectedOption.label);
    setRateCode(selectedOption.customElements.code);
    setRateType(selectedOption.customElements.type);
    setRateTypeTax(selectedOption.customElements.typeTax);
    setRateTypeTVA(selectedOption.customElements.typeTVA);
    setRateSelectPlaceHolder(selectedOption.label);
    setValueRate(selectedOption.customElements.value);
  };
  const onChangeValueRateHandler = (event) => {
    setValueRate(event.target.value);
  };
  const onChangeRefBillHandler = (event) => {
    setRefBill(event.target.value);
  };
  const blocRefFacture = () => {
    if (rateTypeTax === 2 && rateType === 1) {
      return (
        <div className="col-md-5">
          <label>Référence facture:</label>
          <input
            type="Ref"
            className="form-control"
            placeholder="Ajouter Référence"
            value={refBill}
            onChange={onChangeRefBillHandler}
          />
        </div>
      );
    } else {
      return <div className="col-md-5"></div>;
    }
  };
  const blocRates = () => {
    if (rateChoosen !== null) {
      if (rateTypeTax === 1) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
                disabled
              />
            </div>
            {blocRefFacture()}
          </>
        );
      } else if (rateTypeTax === 2) {
        return (
          <>
            <div className="col-md-6">
              <label>Valeur:</label>
              <input
                onChange={onChangeValueRateHandler}
                type="number"
                value={valueRate}
                min="0"
                id="unitPrice"
                className="form-control"
              />
            </div>
            {blocRefFacture()}
          </>
        );
      }
    }
  };

  // const onAddTaxeToList = (event) => {
  //   if (rateChoosen === null) {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText("Erreur : Sélectionnez un taxe ");
  //   }
  //   if (valueRate == null) {
  //     setOpenErrorAlert(true);
  //     setErrorAlertText("Erreur :le valeur est vide ! ");
  //   } else {
  //     setRateTableData((previoustate) => [
  //       ...previoustate,
  //       {
  //         idRate: rateChoosen,
  //         name: rateName,
  //         value: valueRate,
  //         code: rateCode,
  //         type: rateType,
  //         typeTax: rateTypeTax,
  //         typeTVA: rateTypeTVA,
  //         refBill: refBill,
  //       },
  //     ]);
  //     setRefBill("");
  //     setRateChoosen(null);
  //     setRateSelectPlaceHolder("choisir une taxe ou frais");
  //     setRateName("");
  //     setRateCode("");
  //     setRateType("");
  //     setValueRate("");
  //   }
  // };

  const onAddTaxeToList = (event) => {
    let rateId = null;
    let exist = false;
    let indexInRateTable;
    try {
      rateTableData.forEach((element, index) => {
        console.log("element", element);

        if (element.code === rateCode) {
          indexInRateTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    console.log("exist", exist);
    if (rateChoosen === null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un taxe ");
    }
    if (valueRate == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur :le valeur est vide ! ");
    } else {
      if (!exist) {
        setRateTableData((previoustate) => [
          ...previoustate,
          {
            idRate: rateChoosen,
            name: rateName,
            value: valueRate,
            code: rateCode,
            type: rateType,
            typeTax: rateTypeTax,
            typeTVA: rateTypeTVA,
            refBill: refBill,
          },
        ]);
      } else if (exist) {
        let rateUpdateValue = rateTableData[indexInRateTable];

        if (rateTableData[indexInRateTable].value !== valueRate) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la valeur de " + rateName
          );
        }
        rateUpdateValue.idRate = rateChoosen;
        rateUpdateValue.name = rateName;
        rateUpdateValue.value = valueRate;
        rateUpdateValue.code = rateCode;
        rateUpdateValue.type = rateType;
        rateUpdateValue.typeTax = rateTypeTax;
        rateUpdateValue.typeTVA = rateTypeTVA;
        rateUpdateValue.refBill = refBill;
        let modelData = update(rateTableData, {
          [indexInRateTable]: { $merge: rateUpdateValue },
        });

        setRateTableData(modelData);
      }
      setRefBill("");
      setRateChoosen(null);
      setRateSelectPlaceHolder("Choisir une taxe");
      setRateName("");
      setRateCode("");
      setRateType("");
      setValueRate("");
    }
  };
  function buttonFormatter(cell, row) {
    if (row.typeTax === 1) {
      if (row.typeTVA === 1) {
        // return <span>Tax, avant TVA</span>;
        return <span>Tax, sur HTC</span>;
      } else if (row.typeTVA === 2) {
        // return <span>Tax, après TVA</span>;
        return <span>Tax, sur TTC</span>;
      }
    } else if (row.typeTax === 2) {
      if (row.type === 1) {
        return <span>Charge, avec facture</span>;
      } else if (row.type === 2) {
        return <span>Charge, sans facture</span>;
      }
    }
  }
  const columnsRate = [
    {
      dataField: "code",
      text: "Code",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "name",
      text: "Libellé",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "typeTax",
      text: "Type",
      formatter: buttonFormatter,
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "value",
      text: "Valeur %",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "idRate",
      text: "Supprimer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("rateTableData cell", rateTableData);

          setRateTableData(
            rateTableData.filter((item) => item.idRate !== row.idRate)
          );
        },
      },
    },
  ];

  const getProdcutsAndDevisByWarehouse = (event) => {
    if (warehousePriceId !== 0) {
      startLoading();

      // setProductBloc(true);
      SellingService.getAllBDCNotArchived(getCurrentUserId(), warehousePriceId)
        .then((response) => {
          if (Object.keys(response.data)[0] === "empty") {
            setAvailableBDCSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element["ref"], label: element["ref"] };
              backendData.push(elem);
            });
            setAllAvailableBDC(backendData);
            setAvailableBDCSelectPlaceHolder("Choisir...");
          }
        })
        .catch((error) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + error);
        })
        .finally(() => {
          stopLoading()
        });
      startLoading();

      SellingService.getAllDevisNotRelatedToBDCeNotArchived(
        getCurrentUserId(),
        warehousePriceId
      )
        .then((response) => {
          console.log("DevisBC", response);

          if (Object.keys(response.data)[0] === "empty") {
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Vide");
          } else if (Object.keys(response.data)[0] === "success") {
            let backendData = [{}];
            response.data.success.map((element) => {
              let elem = { value: element["ref"], label: element["ref"] };
              backendData.push(elem);
            });
            setAllAvailableDevisNotRelatedToBdc(backendData);
            setAvailableDevisNotRelatedToBDCSelectPlaceHolder("Choisir...");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        })
        .finally(() => {
          stopLoading()
        });

      startLoading();
      SellingService.getAllProductsOnSaleV2(
        getCurrentUserId(),
        1,
        warehousePriceId
      )
        .then((response) => {
          if (response.data.success) {

            setAllProducts([{}]);
            response.data.success && setAllProducts(response.data.success);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : pas de dépôt");
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);

          setErrorAlertText("Erreur : " + e);
        })
        .finally(() => {
          stopLoading()
        });

      setProductBloc(true);
    }
  };
  function blocProducts() {

    if (productBloc && warehouseSourceId !== 0) {
      return (
        <div>
          <div class="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label>
                  Vous pouvez choisir la référence d'un devis pour le
                  confirmer
                </label>
                <div className="input-group">
                  <div
                    className="input-group-prepend"
                    style={{ width: "95%" }}
                  >
                    <Select
                      styles={styles}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={
                        availableDevisNotRelatedToBDCSelectPlaceHolder
                      }
                      onChange={onChangeQuotationReferenceHandler}
                      options={allAvailableDevisNotRelatedToBdc}
                      placeholder={
                        availableDevisNotRelatedToBDCSelectPlaceHolder
                      }
                    />
                  </div>
                  <div className=" input-group-append">
                    <button
                      onClick={onGetDevisByReference}
                      type="button"
                      class="btn btn-dark"
                    >
                      <i class="fas  fa-solid fa-arrow-down"></i>
                    </button>
                  </div>
                </div>
              </div>

              <div>
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>
                        Vous pouvez choisir la référence d'un bon de commande
                        existant pour obtenir ses produits
                      </label>
                      <div className="input-group">
                        <div
                          className="input-group-prepend"
                          style={{ width: "95%" }}
                        >
                          <Select
                            styles={styles}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={availableBDCSelectedOption}
                            onChange={onChangeBDCReferenceHandler}
                            options={allAvailableBDC}
                            placeholder={availableBDCSelectPlaceHolder}
                          />
                        </div>

                        <div className=" input-group-append">
                          <button
                            onClick={onGetBDCByReference}
                            type="button"
                            class="btn btn-dark"
                          >
                            {" "}
                            <i class="fas  fa-solid fa-arrow-down"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div>
                        <label>
                          Choisir un produit{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>

                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOption}
                          onChange={onChangeSelectedProduct}
                          options={allProducts}
                          placeholder={productSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">
                        Prix.U.H.T ( {estimDevise})
                      </label>
                      <input
                        onChange={onChangeUnitPriceHandler}
                        value={estimUnitPrice}
                        // disabled="true"
                        min="0"
                        id="unitPrice"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">
                        TVA ({estimTva}%)
                      </label>
                      <input
                        value={estimTva}
                        disabled="true"
                        onChange={onChangeTvaHandler}
                        min="0"
                        id="tva"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">
                        Quantité
                        {/* <span style={{ color: "red" }}>*</span> (
                            {estimQte}) */}
                      </label>
                      <input
                        onChange={onChangeQuantityHandler}
                        value={quantity}
                        type="number"
                        min="0"
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                      <label>Choisir un Lot</label>

                      <Select
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOptionLot}
                        onChange={onChangeSelectedLot}
                        options={allLot}
                        placeholder={lotSelectPlaceHolder}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Choisir le type de promotion</label>
                      <select
                        value={promotionType}
                        onChange={(e) => setPromotionType(e.target.value)}
                        className="form-control select2"
                        style={{ width: "100%" }}
                      >
                        <option key={1} value={"pourcentage"} selected="selected">
                          Pourcentage
                        </option>
                        <option key={2} value={"montant"}>
                          Montant
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="inputClientCompany">Promotion</label>
                      <input
                        value={promotionPercentage}
                        onChange={onChangePromotionHandler}
                        type="number"
                        min="0"
                        id="promotion"
                        className="form-control"
                      />
                    </div>
                  </div>
                <div className="col-sm-12">
                  <div className="form-group">
                    <label htmlFor="lineNote">Note du produit (facultatif)</label>
                    <textarea
                      id="lineNote"
                      rows={2}
                      maxLength={500}
                      value={lineNote}
                      onChange={(e) => setLineNote(e.target.value)}
                      className="form-control"
                      placeholder="Remarque propre à cette ligne (texte libre)"
                    />
                  </div>
                </div>

                </div>

                <div class="row">
                  <div className="col-sm-12  text-center">
                    <button
                      style={{ marginBottom: 20 }}
                      className="btn btn-dark"
                      onClick={onAddProductToList}
                    >
                      <i class="fas fa-plus"></i>
                      Liste des ventes{" "}
                    </button>
                  </div>
                </div>

                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      {productTableData && (
                        <ToolkitProvider
                          keyField="idProduct"
                          data={productTableData}
                          columns={columnsWithDelete}
                          onTableChange={handleTableChange}
                        >
                          {(props) => (
                            <div>
                              <div className="row">
                                <BootstrapTable
                                  {...props.baseProps}
                                  headerClasses="thead-light"
                                  wrapperClasses="table-responsive w-100"
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setBCFile(e.target.files[0]);
    }
  };
  const onChangeRefBCHandler = (event) => {
    setRefBC(event.target.value);
  };
  const blocButtonAddRates = () => {
    if (rateChoosen !== null) {
      return (
        <div className="row">
          <div className="col-md-8"></div>
          <div className="col-md-4">
            <button class="btn btn-dark  float-right" onClick={onAddTaxeToList}>
              <i class="fas fa-plus"></i>
              Ajouter taxe
            </button>
          </div>
        </div>
      );
    }
  };

  const getRemiseBloc = () => {
    if (showConditionCommercialClient && conditionCommercialClient !== null) {
      console.log("conditionCommercialClient", conditionCommercialClient);
      console.log("amount", conditionCommercialClient.conditionCommercialTiers?.amount);

      if (conditionCommercialClient.conditionCommercialTiers?.amount !== 0 && conditionCommercialClient.conditionCommercialTiers?.amount !== "0") {
        // console.log("amount",conditionCommercialClient.conditionCommercialTiers?.amount);


        return (
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>
                  Montant du CC: {conditionCommercialClient.conditionCommercialTiers.amount} DNT</label></div></div></div>
        )

        // discountType
      } else if (conditionCommercialClient.conditionCommercialTiers?.percent !== 0 && conditionCommercialClient.conditionCommercialTiers?.percent !== "0") {


        return (

          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label>Pourcentage du CC: {conditionCommercialClient.conditionCommercialTiers.percent} %</label></div></div></div>
        )
      }

      //   return ( <div className="row">
      //   <div className="col-sm-6">
      //     <div className="form-group">
      //       <label>Choisir le type de Remise </label>
      //       <select
      //         value={discountType}
      //         onChange={onChangeDiscountTypeHandler}
      //         className="form-control select2"
      //         style={{ width: "100%" }}
      //       >
      //         <option key={1} value={"pourcentage"} selected="selected">
      //           Pourcentage
      //         </option>
      //         <option key={2} value={"montant"}>
      //           Montant
      //         </option>
      //       </select>
      //     </div>
      //   </div>
      //   <div className="col-sm-6">
      //     <div className="form-group">
      //       <label htmlFor="inputClientCompany">Remise</label>
      //       <input
      //         value={discount}
      //         onChange={onChangeDiscountHandler}
      //         type="number"
      //         min="0"
      //         id="inputRemiseClientCompany"
      //         className="form-control"
      //       />
      //     </div>
      //   </div>
      // </div>
      //   )
    }



  }
  function lotFormatter(cell, row) {
    if (cell === 1) {
      return <span>Nouveau sortie</span>;
    } else if (cell === 3) {
      return <span>Sorti du retours</span>;
    }
  }
  const columns = [
    {
      dataField: "productName",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "type",
      text: "type",
      align: "center",
      headerAlign: "center",
      formatter: lotFormatter,
    },
    {
      dataField: "stockedQte",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12 row">
                <div className="form-group flex-grow-1">
                  <label>
                    Choisir le dépôt <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "90%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedWarehouseSource}
                        options={allWarehouseSource}
                        placeholder={warehouseSelectPlaceHolder}
                      />
                    </div>
                    {/*<div className=" input-group-append">
                      <button
                        onClick={getProdcutsAndDevisByWarehouse}
                        type="button"
                        class="btn btn-dark"
                      >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                      </button>
                     </div>*/}
                  </div>
                </div>
                <div className="form-group flex-grow-1">
                  <label>
                    Choisir le dépôt de prix <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="input-group">
                    <div
                      className="input-group-prepend"
                      style={{ width: "90%" }}
                    >
                      <Select
                        styles={styles}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        defaultValue={selectedOption}
                        onChange={onChangeSelectedWarehousePrice}
                        options={allWarehousePrice}
                      // placeholder={warehouseSelectPlaceHolder}
                      />
                    </div>
                    <div className=" input-group-append">
                      <button
                        onClick={getProdcutsAndDevisByWarehouse}
                        type="button"
                        class="btn btn-dark"
                      >
                        <i class="fas  fa-solid fa-arrow-down"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {blocProducts()}

            {/*  */}
          </div>
        );
      case 1:
        return (
          <div>
            <div className="card card-outline card-secondary mb-3">
              <div className="card-header py-2">
                <strong>
                  <i className="fas fa-user mr-2"></i>Client et livraison
                </strong>
              </div>
              <div className="card-body pb-1">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="clientSelectBdc">
                        Client <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="d-flex align-items-start">
                        <div style={{ flex: 1 }}>
                          <Select
                            styles={styles}
                            isDisabled={createBDCFromDevis}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={clientSelectedOption}
                            onChange={onChangeSelectedClient}
                            options={allClients}
                            placeholder={clientSelectPlaceHolder}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn btn-outline-dark ml-2"
                          title="Ajouter un client"
                          onClick={() => setShowQuickClient(true)}
                        >
                          <i className="fas fa-user-plus"></i>
                        </button>
                      </div>
                      {showQuickClient && (
                        <QuickAddClient
                          onClose={() => setShowQuickClient(false)}
                          onCreated={onClientCreated}
                        />
                      )}
                      {seuil !== null && seuil !== undefined && (
                        <small className="text-muted">
                          Seuil restant du client : {Number(seuil).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="estimatedDeliveryDate">Livraison estimée</label>
                      <input
                        id="estimatedDeliveryDate"
                        type="date"
                        className="form-control"
                        value={estimatedDeliveryDate}
                        onChange={(e) => setEstimatedDeliveryDate(e.target.value)}
                      />
                      <div className="mt-1">
                        {[7, 14, 30].map((days) => (
                          <button
                            key={days}
                            type="button"
                            className="btn btn-xs btn-outline-secondary mr-1"
                            onClick={() => {
                              const d = new Date();
                              d.setDate(d.getDate() + days);
                              setEstimatedDeliveryDate(d.toLocaleDateString("en-CA"));
                            }}
                          >
                            +{days} j
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor="refBC">Référence</label>
                      <input
                        value={refBC}
                        onChange={onChangeRefBCHandler}
                        type="text"
                        id="refBC"
                        className="form-control"
                        placeholder="Auto si vide"
                      />
                    </div>
                  </div>
                </div>
                {getRemiseBloc()}
              </div>
            </div>

            <div className="card card-outline card-secondary mb-3">
              <div className="card-header py-2">
                <strong>
                  <i className="fas fa-align-left mr-2"></i>Description
                </strong>
              </div>
              <div className="card-body pb-1">
                <div className="form-group">
                  <label htmlFor="documentLanguage">Langue du document</label>
                  <select
                    id="documentLanguage"
                    className="form-control"
                    value={documentLanguage}
                    onChange={(e) => setDocumentLanguage(e.target.value)}
                    disabled={createBDCFromDevis}
                  >
                    <option value="fr">Français</option>
                    <option value="en">English</option>
                  </select>
                  <small className="text-muted">Le document généré (PDF) suit cette langue.</small>
                </div>
                <div className="form-group">
                  <label htmlFor="inputClientCompany">
                    Titre <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    value={ordreTitle}
                    required="required"
                    onChange={onChangeOrdreTitleHandler}
                    type="text"
                    id="inputClientCompany"
                    className="form-control"
                    placeholder="Ex : Commande de mars"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="inputDescription">
                    Note du bon de commande <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    value={ordreDesignation}
                    placeholder="Informations utiles pour la préparation et la livraison"
                    onChange={onChangeOrdreDesignationHandler}
                    id="inputDescription"
                    className="form-control"
                    rows={3}
                    required
                  />
                </div>
              </div>
            </div>

            <OptionalSection title="Fichier joint et taxes">
            <div className="row">
              <div className="col-sm-12">
                <div class="form-group">
                  <label for="exampleInputFile">Bon de commande </label>
                  <div class="input-group">
                    <div class="custom-file">
                      <input
                        accept="application/pdf, .jpg, .jpeg, .png"
                        type="file"
                        className="custom-file-input"
                        id="exampleInputFile"
                        onChange={onUploadFileHandler}
                      />
                      <label class="custom-file-label" for="exampleInputFile">
                        Entrer le fichier de BC
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-6">
                <div className="form-group">
                  <label>Choisir une taxe</label>
                  <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionRate}
                    onChange={onChangeSelected}
                    options={allRates}
                    placeholder={rateSelectPlaceHolder}
                  />
                </div>
              </div>
              {blocRates()}
            </div>
            {blocButtonAddRates()}

            <br />
            <div className="row">
              <div className="col-md-12">
                {rateTableData && (
                  <ToolkitProvider
                    keyField="rateTable"
                    data={rateTableData}
                    columns={columnsRate}
                    onTableChange={handleTableChangeRate}
                  >
                    {(props) => (
                      <div>
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      </div>
                    )}
                  </ToolkitProvider>
                )}
              </div>
            </div>
            </OptionalSection>
            <div className="card card-outline card-dark mb-0">
              <div className="card-body py-3">
                <div className="row text-center">
                  <div className="col-sm-4">
                    <small className="text-muted text-uppercase d-block">Total HT</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number(bcPriceHt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                  <div className="col-sm-4">
                    <small className="text-muted text-uppercase d-block">TVA</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number((bcPriceTt || 0) - (bcPriceHt || 0)).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                  <div className="col-sm-4">
                    <small className="text-muted text-uppercase d-block">Total TTC</small>
                    <strong style={{ fontSize: "1.3rem" }}>
                      {Number(bcPriceTt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <span class="text-dark">
              L'enregistrement du bon de commande
            </span>
          </div>
        );
      case 3:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <h5>Envoyer une commande au client</h5>
              </div>
            </div>

            <div class="row">
              <div className="col-sm-12">
                <div className="form-group">
                  {productTableDataForLivraison && (
                    <ToolkitProvider
                      keyField="idProduct"
                      data={productTableDataForLivraison}
                      columns={columns}
                      onTableChange={handleTableChange}
                    >
                      {(props) => (
                        <div className="row">
                          <BootstrapTable
                            {...props.baseProps}
                            headerClasses="thead-light"
                            wrapperClasses="table-responsive w-100"
                            striped
                            hover
                            condensed
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const onAddProductToList = (event) => {
    let productRef = null;
    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        console.log("element", element);
        if (element.idProduct === productId) {
          indexInDataTable = index;
          productRef = element.productRef;
          exist = true;
          console.log("productMapById indexInDataTable", indexInDataTable);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }
    try {
      allProducts.forEach((element) => {
        if (element.value === productId) {
          productRef = element.customElements.name;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    // else if (unitPrice === 0) {
    //   setOpenErrorAlert(true);
    //   setErrorAlertText(
    //     "Erreur : le prix unitaire doit être supérieur à zéro "
    //   );
    // }
    // else if (quantity === 0 || quantity < 0) {
    //   setOpenErrorAlert(true);
    //   setErrorAlertText("La quantité du produit doit être supérieur à 0 ");
    // }
    if (productId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Sélectionnez un produit ");
    } else {
      if (modeProduct === 0) {
      }
      let result = UtilsFormuleSell.CalculatePromotionProductSELL(
        promotionPercentage,
        promotionType,
        montantDevis,
        quantity,
        tva
      );
      console.log("result add product table", result);
      let promotionAmountOrPersentage = result[0];
      let sellingPrice = result[1];
      let promotionpercent = result[2];
      let ttPrice = Math.round((result[3] * 1000) / 1000);

      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            sellingPrice: sellingPrice,
            idLot: idLot,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productId,
            initialPriceHtc: montantDevis,
            quantity: quantity,
            tva: tva,
            idLot: idLot,
            sellingPrice: sellingPrice,
            currency: deviseChoosen,
            currencyPrice: unitPrice,
            exchangeRate: tauxChange,
            isImport: modeProduct,
            htPrice: promotionAmountOrPersentage,
            ttPrice: Math.round((ttPrice * 1000) / 1000),
            promotionPercentage: promotionpercent,
            note: lineNote,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.promotionPercentage = promotionPercentage;
        productUpdateValue.initialPriceHtc = montantDevis;
        productUpdateValue.quantity = quantity;
        productUpdateValue.tva = tva;
        productUpdateValue.sellingPrice = sellingPrice;
        productUpdateValue.htPrice = promotionAmountOrPersentage;
        productUpdateValue.ttPrice = Math.round((ttPrice * 1000) / 1000);
        productUpdateValue.note = lineNote;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].initialPriceHtc !== unitPrice) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " + productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionType !== promotionType
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit :  " + productRef
          );
        } else if (
          productTableData[indexInDataTable].promotionPercentage !==
          promotionPercentage
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].quantity !== quantity) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        } else if (productTableData[indexInDataTable].tva !== tva) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé le produit : " + productRef
          );
        }

        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    console.log("productTableData -------------- ", productTableData);
  };
  function etatInitial() {
    setLineNote("");
    setSelectedOption(null);
    setProductSelectPlaceHolder("Choisir...");
    setUnitPrice(0);
    setQuantity(1);
    setTva(0);
    setSelectedOptionMode(null);
    setPromotionType("pourcentage");
    setPromotionPercentage(0);
    setSelectedOptionLot(null);
    setLotSelectPlaceHolder("Choisir...");
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <style>{`
        .quotation-form .form-group > label,
        .quotation-form .input-group > label {
          font-size: 0.8rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.03em;
          color: #6c757d;
        }
      `}</style>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-alt mr-2"></i>Nouveau bon de commande avec dépôt de prix
              </h4>
              <small className="text-muted">
                Choisissez le dépôt et les produits, saisissez les informations
                du client puis validez le bon de commande
              </small>
            </div>
            <button
              className="btn btn-outline-secondary mt-2 mt-sm-0"
              onClick={() => navigate("/bonCommandeVente")}
            >
              <i className="fas fa-arrow-left mr-1"></i>
              Retour aux bons de commande
            </button>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mt-3">
            <div className="col-md-12">
              <div
                className="card card-outline card-dark quotation-form"
                style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
              >
                
                {activeStep === steps.length ? (
                  <div>
                    <div className="card-body text-center py-5">
                      <i
                        className="fas fa-check-circle fa-3x mb-3 d-block"
                        style={{ color: "#28a745" }}
                      ></i>
                      <h5>Toutes les étapes ont été complétées avec succès</h5>
                    </div>
                    <div className="card-footer text-right">
                      <button className="btn btn-dark" onClick={handleReset}>
                        <i className="fas fa-undo mr-1"></i>
                        Nouveau bon de commande
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="card-body">{activeStep <= 2 ? (
                      <>
                        <h5 className="mb-3">
                          <i className="fas fa-boxes mr-2"></i>1. Produits
                        </h5>
                        {getStepContent(0)}
                        <hr />
                        <h5 className="mb-3">
                          <i className="fas fa-file-alt mr-2"></i>2. Informations du document
                        </h5>
                        {getStepContent(1)}
                      </>
                    ) : (
                      getStepContent(activeStep)
                    )}</div>
                    <div
                      className="card-footer d-flex justify-content-between align-items-center"
                      style={{ position: "sticky", bottom: 0, background: "#fff", zIndex: 5, boxShadow: "0 -2px 6px rgba(0,0,0,.06)" }}
                    >
                      <div>
                        <small className="text-muted d-block text-uppercase">
                          {productTableData.length} produit(s) · Total HT / TTC
                        </small>
                        <strong style={{ fontSize: "1.1rem" }}>
                          {Number(bcPriceHt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })} /{" "}
                          {Number(bcPriceTt || 0).toLocaleString(undefined, { maximumFractionDigits: 3 })}
                        </strong>
                      </div>

                      <div>
                        {activeStep <= 2 && (
                          <button
                            type="button"
                            className="btn btn-outline-secondary mr-2"
                            onClick={() => navigate("/bonCommandeVente")}
                          >
                            Annuler
                          </button>
                        )}
                        {activeStep <= 2 && (
                          <button
                            type="button"
                            className="btn btn-outline-dark mr-2"
                            disabled={saving || disableTerminer}
                            onClick={() => {
                              printAfterSaveRef.current = true;
                              handleSave();
                            }}
                          >
                            <i className="fas fa-print mr-1"></i>Enregistrer et imprimer
                          </button>
                        )}
                      <button className="btn btn-dark" disabled={saving || disableTerminer} onClick={() => { if (activeStep <= 2) { printAfterSaveRef.current = false; handleSave(); } else { handleNext(); } }}>
                        {activeStep <= 2 ? (
                          <>
                            <i className="fas fa-save mr-1"></i>Enregistrer
                          </>
                        ) : activeStep === steps.length - 1 ? (
                          <>
                            <i className="fas fa-check mr-1"></i>Terminer
                          </>
                        ) : (
                          <>
                            <i className="fas fa-truck mr-1"></i>Valider la livraison
                          </>
                        )}
                      </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      {onGetStockProduct && (
        <StockOfProductSale
          setOnGetStockProduct={setOnGetStockProduct}
          idProduct={productIdStock}
          nameProduct={nameProductStock}
          idWarehouse={warehouseSourceId}
        />
      )}
    </div>
  );
};
export default withLoader(AddBDCSellDepot);

